import { Urls } from '@utils/enums/Urls.enum';
import { createContext, useContext, ReactNode, useMemo } from 'react';

type UrlsType = ReturnType<typeof getUrls>;

type UrlsContextType = {
  Urls: UrlsType;
  basePath: string;
};

const UrlsContext = createContext<UrlsContextType | undefined>(undefined);

export function getUrls(basePath: string) {
  const cleanBase = basePath.replace(/\/$/, '');
  // append Urls enum to the basePath in input
  return Object.fromEntries(
    Object.entries(Urls).map(([key, value]) => [key, `${cleanBase}${value}`]),
  ) as typeof Urls;
}

// Restituisce il contesto (dunque Urls + basePath)
export const useUrlsContext = () => {
  const context = useContext(UrlsContext);
  if (!context)
    throw new Error('useUrlsContext must be used within a UrlsProvider');
  return { Urls: context.Urls, basePath: context.basePath };
};

export const UrlsProvider = ({
  basePath,
  children,
}: {
  basePath: string;
  children: ReactNode;
}) => {
  const cleanBase = basePath.replace(/\/$/, '');
  const Urls = useMemo(() => getUrls(cleanBase), [cleanBase]);
  const value = useMemo(
    () => ({ Urls, basePath: cleanBase }),
    [Urls, cleanBase],
  );
  return <UrlsContext.Provider value={value}>{children}</UrlsContext.Provider>;
};
